import Upload from './components/upload'

Upload.install = (Vue) => {
  Vue.component(Upload.name, Upload)
}

export default Upload



// WEBPACK FOOTER //
// ./packages/upload/index.js